import { UnparsedQueryParams } from '../../types';

export const handleAmeren = ({
  params: { client_id: clientId, code, iss },
}: {
  location?: Location;
  params: UnparsedQueryParams;
}) => {
  // TODO: how should we handle errors?
  if (!code || !iss || !clientId) return;
  return { code, iss, clientId };
};
